export default class MenuOrderComboPanel extends React.Component {
    
    constructor(props) {
        super(props);
        this.goToCatPage = this.goToCatPage.bind(this);
        this.pushGAEvent = this.pushGAEvent.bind(this);
        
    }
    componentDidMount(){
        this.pushGAEvent();
    }
    pushGAEvent() {
        var products = [];
        var brand = '';
        var chainId = $('#hdnChainProductId').val()
       
    
        try {
            if ($("body").hasClass("ihop-wrapper")) {
                brand = 'Ihop';
            }
            products.push({
                'name': this.props.name,
                'id': chainId,
                'price': this.props.dollarPrice,
                'brand': brand,
                'category': this.props.category
            });
            var attributionToken = this.getUrlParameter('attributionToken');
            var ecommerce = {
                'currencyCode': 'USD',
                'detail': {
                    'actionField': '',
                    'attribution_token': (attributionToken === '') ? undefined :attributionToken,
                    'products': products
                }
            }
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                "event": "product-detail-view",
                "ecommerce": ecommerce
            });
        }
        catch (e) {
            console.log(e);
        }
    }
    getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
    goToCatPage(e){
        var cartegoryPageUrl = ("../" + this.props.categoriesPageUrl.split('/')[3]).toString();
        console.log('cartegoryPageUrl--' + cartegoryPageUrl);
        $("a.back-link").attr("href", cartegoryPageUrl)
        console.log('cartegoryPageUrl2--' + cartegoryPageUrl);
    }
    render() {
        
        return (
            <div>
                {/*<!-- ==== IHOP COMBO SECTION ==== -->*/}
            <div className="combo-box">
                {/*<!-- actions buttons back/fav  -->*/}
                <div className="action-btns">
                  <div className="row align-items-center justify-content-center">
                      {/*<!-- back button -->*/}
                    <div className="col-6">
                      <a className="text-left back-link" onClick={this.goToCatPage} href="#" title="back navigation">
                        <img src="/images/2/icons/back-nav.png" className="img-fluid" alt="back nav button" />
                      </a>
                    </div>
                      {/*<!-- back button -->*/}

                      {/*<!-- favourite button -->*/}
                    <div className="col-6">

                    </div>
                      {/*<!-- favourite button -->*/}
                  </div>
                    {/*<!-- /.row -->*/}
                </div>
                {/*<!-- actions buttons back/fav  -->*/}

                {/*<!-- combo-body -->*/}
                <div className="combo-body">

                  <div className="row">
                    <div className="col-12">
                        {/*<!-- combo image-->*/}
                      <picture>
                        <source media="(max-width: 767px)" srcset="" />
                        <img alt={this.props.altImage} className="img-fluid" src={this.props.image} />
                      </picture>
                        {/*<!-- combo image -->*/}
                    </div>
                    <div className="col-12 order-first order-md-0">
                                <h1 className="combo-title">
                                <span>{this.props.name}</span>
                                    {
                                        (typeof this.props.menuLabels !== 'undefined') ? (
                                            this.props.menuLabels.filter(labels => (labels.Code.toLowerCase() == "nychighsodium" || labels.Code.toLowerCase() == "phlsodiumwarning")).map(filteredLabel => (
                                                <span className={"c-" + filteredLabel.Code.toLowerCase()}>
                                                <img src={(filteredLabel.Code.toLowerCase() == "nychighsodium" ? "/-/media/ihop/images/icons/nyc_sodium-warning.png" :
                                                    "/-/media/ihop/images/icons/phl_sodium-warning.png")} alt="warning image" data-code={filteredLabel.Code.toLowerCase()} class="warning-img img-fluid" />
                                                </span>
                                            ))
                                        ) : null}
                                </h1>

                        {(this.props.calcPrice > 0) ?
                            (
                                (this.props.baseCalories && this.props.baseCalories != "")?
                                <h2 className="combo-price">
                                    {this.props.dollarPrice}
                                    <span>&nbsp;&nbsp;|&nbsp; &nbsp;{this.props.baseCalories}{this.props.calSeparator != "" ? this.props.calSeparator : " "}{this.props.maxCalories != "" ? this.props.maxCalories : ""} {this.props.caloriesText}</span>
                                </h2> :
                                <h2 className="combo-price">{this.props.dollarPrice}</h2>
                            ) :
                            (
                                (this.props.baseCalories && this.props.baseCalories != "") ?
                                <h2 className="combo-price">
                                    <span>{this.props.baseCalories}{this.props.calSeparator != "" ? this.props.calSeparator : " "}{this.props.maxCalories != "" ? this.props.maxCalories : ""} {this.props.caloriesText}</span>
                                </h2>
                                : null
                             )
                        }
                      <p className="combo-description">{this.props.description}</p>
                    </div>
                  </div>
                </div>
                {/*<!-- combo-body -->*/}

                {/*<!-- combo message -->*/}
                <div className="combo-message text-center">
                        <p>{this.props.comboMessage}</p>
                        
                </div>
                {/*<!-- combo message -->*/}
                </div>  

                <p id="part-bot" className="bot-para d-none"><strong>{this.props.deliveryFeeStandard}</strong></p>

                {/*<!-- ==== IHOP COMBO SECTION  ==== --></div>*/}
            </div>
        );
                                                    }
                                                    }

